import { render, staticRenderFns } from "./k-new-folder.vue?vue&type=template&id=a1bfd798&scoped=true&"
import script from "./k-new-folder.vue?vue&type=script&lang=ts&"
export * from "./k-new-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bfd798",
  null
  
)

export default component.exports